<template>
  <div class="widgetFilterForm" :class="modalTheme">
    <!-- selectedTaskFilters {{  selectedTaskFilters }} -->

    <span v-if="AreIdsShown" style="background: darkred; color: yellow"> INC workTaskFilters {{ workTaskFilters }}</span>
    <br />
    <span v-if="AreIdsShown" style="background: darkblue; color: yellow"> INC selectedTaskFilters {{ selectedTaskFilters }}</span>
    <!-- <br> -->

    <!-- <b-button type='button' variant='success' @click='onReset'>expandALl {{ selectedFilters }} </b-button> -->

    <!-- <h6> INC workTaskFilters {{workListStore.widgetTaskFilters.taskTypeOptions.filter( task => Includes(workTaskFilters))}}</h6>
    selectedFilters {{ selectedFilters }}
    selectedSet {{ selectedSet }} -->

    <div :class="modalTheme">
      <!-- <button @click="onBind"> BIND sTask to Sel</button>
			<button @click="onReset"> Clear sel</button>
			<button @click="updateSelectedList"> updateSelectedList</button> -->

      <!-- <b-form-group v-slot="{ ariaDescribedby }">
				<label>Task Filters:</label>
				<b-form-checkbox-group id="checkbox-group-1" v-model="selected" :options="workTaskFilters"
					:aria-describedby="ariaDescribedby" name="flavour-1" switches size="sm"
					@change="update_checkboxes"></b-form-checkbox-group>
			</b-form-group> -->

      <b-form-group :class="modalTheme" label="Task Filter:" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          :class="modalTheme"
          id="checkbox-group-new"
          v-model="selectedTaskFilters"
          :options="workTaskFilters"
          :aria-describedby="ariaDescribedby"
          name="flavour-1"
          switches
          size="sm"
          @change="update_checkboxes"
        ></b-form-checkbox-group>
      </b-form-group>

      <pre v-if="AreIdsShown">selectedTaskFilters: <strong>{{ selectedTaskFilters }}</strong></pre>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, toRaw } from "vue";
// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
import { useStoreWorkList } from "@/stores/workListsStore";

// variable
const msg = "Hello! from WidgetFilters EMITTER events   eventA and eventB ";

// & PROPS
const props = defineProps({
  selectedTaskFilters: {
    type: Array,
    default: () => [],
  },
  workTaskFilters: {
    type: Array,
    default: () => [],
  },
});

const workListStore = useStoreWorkList();

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);
const selectedTaskFilters = ref([]); // Must be an array reference!

const myOptions = ref(workListStore.widgetWorkFilters?.priorityOptions);

// * EMITTER
const emit = defineEmits(["selectedFilters", "eventA", "eventB"]);

function update_checkboxes(e) {
  // console.clear()
// console.log("       update_checkboxes");

// console.log("      STR >> setWidgetTaskFilters");

  let curSId = workListStore.currentSelectedWorkSummaryWidget.id;
  // let curSTaskFilter = this.selected

// console.log(" IS THIS    local  or PROP   >>>> ");
  let curSTaskFilter = selectedTaskFilters.value;

// console.log(curSId);
  //
// console.log(curSTaskFilter);
  // console.log(curSTaskFilter.value)

// console.log("&&&&&&&&&");

// console.log("NEW STUB   set widget PUSHES TO     this.currentSelectedWorkSummaryWidget.selectedTaskTypeFilter              <<<<<<<<<<<<<} ");
  // this.$store.commit('setWidgetTaskFilters', e)
  // console.log(e)
  // console.log('       BIND to workWIdget              NEW tthis.workWidgetSummaryList.selectedTaskTypeFilters  = e')
  // workListStore.workWidgetSummaryList.selectedTaskTypeFilters = e
  // this.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters = e

  // console.log('***           currentSelectedWorkSummaryWidget.selectedTaskTypeFilters'              )
  // console.log(this.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters)
// console.log("***");
  //
  // console.log(' 			BIND to workWIdget							NEW tthis.workWidgetSummaryList.selectedTaskTypeFilters  = e')
  // workListStore.workWidgetSummaryList.selectedTaskTypeFilters = e

  let o1 = { curSId, curSTaskFilter };
// console.log("     setWidgetTaskFilters o1  OBJECT");
// console.log(o1);
  // this.$store.commit('setWidgetTaskFilters', o1)

  workListStore.setWidgetTaskFilters(o1);

// console.log("                 @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@                      STR >> filterWidgetGrid");

  // console.log('this.selected :  ', this.selected)
  // console.log("props.selectedTaskFilters : ", props.selectedTaskFilters.value);

  // console.log("                 ccccccccccccccc         this.onBind()        STR >> filterWidgetGrid");
  // this.$store.commit('filterWidgetGrid', this.selectedTaskFilters)

// console.log("     filterWidgetGrid gri8d obk DIG");
// console.log(curSTaskFilter);

  workListStore.filterWidgetGrid(curSTaskFilter);

  // console.log("                     NEW EMITTER on checkCHANGE    *** selectedFilters");
  // this.$emit('selectedFilters', curSTaskFilter)
  emit("selectedFilters", curSTaskFilter);
}

onMounted(() => {
  // console.clear();

// console.log("onMounted() :      		WORK 		WIDGET FILTERS >>>>");

// console.log("props : ");
// console.log(props);
// console.log(props.selectedTaskFilters);
// console.log(props.workTaskFilters);

// console.log(" 	. . . . .  widgetWorkFilters 	create() ");

  //   console.log("workListStore.widgetWorkFilters");
  //   console.log(workListStore.widgetWorkFilters.priorityOptions.length);

  //   console.log("myOptions");
  //   console.log(myOptions.value.length);
});
</script>

<style scoped>
.widgetFilterForm {
  border: 2px solid #dcf1de;
  border-radius: 1.5px;
  padding-left: 10px;
  padding-right: 05px;
  margin-left: 0%;
  /* height: 100px !important   b0c1b2*/
  /* max-width: 884px !important */
  width: auto !important;
  font-weight: 700;
  font-size: 9pt;
  max-height: 200px;
  text-align: left;
}

.btn-primary-green {
  color: #007bff;
  border: none;
  text-decoration: none;
  background-color: transparent;
}

.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}

.custom-select-sm {
  height: calc(0.875rem + 0.5rem + 3px);
}
</style>
